import { twMerge } from "tailwind-merge";

type DatasetCardHeaderProps = {
  showLogo?: boolean;
  rightIcon?: React.ReactNode;
  titleClassName?: string;
  datasetName?: string;
  logoUrl?: string;
  shortDescription?: string;
};

export const DatasetCardHeader = ({
  showLogo,
  rightIcon,
  titleClassName,
  datasetName,
  logoUrl,
  shortDescription
}: DatasetCardHeaderProps) => {
  return (
    <div className="flex justify-between shrink-0 items-start">
      <div className="flex gap-2 items-start flex-1 min-w-0">
        {showLogo && (
          <div className="h-10 w-10 border border-[#E5E7EB] rounded-lg flex items-center justify-center bg-white">
            {logoUrl ? (
              <img
                src={logoUrl}
                alt={`logo-${datasetName}`}
                className="h-8 w-8"
              />
            ) : null}
          </div>
        )}
        <div className="flex flex-col gap-1 flex-1 min-w-0">
          <p
            className={twMerge(
              "text-sm text-txtHeading font-bold text-left line-clamp-2 min-h-[2.5rem]",
              titleClassName
            )}
            title={datasetName}
          >
            {datasetName}
          </p>
          <p
            className="text-xs text-left line-clamp-2"
            title={shortDescription}
          >
            {shortDescription}
          </p>
        </div>
      </div>
      <div className="shrink-0">{rightIcon}</div>
    </div>
  );
};
